function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/helpers/classCallCheck.js
// module id = 3
// module chunks = 0 1 2 4